import { __awaiter, __generator } from "tslib";
import { Simulate } from 'react-dom/test-utils';
export var createDeprecatedSelectDriver = function (wrapper, className, isV3, portalTargetWrapper) {
    var classNames = isV3 ? '.new-select' : className ? ".select." + className : '.select';
    var select = wrapper.$(classNames);
    var selectMenu = portalTargetWrapper ? portalTargetWrapper.$('.select-v3__menu-portal') : select;
    var mouseDownOnElement = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var rawElem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!isV3 && e.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, e.getNative()];
                case 1:
                    rawElem = _a.sent();
                    Simulate.mouseDown(rawElem);
                    return [2 /*return*/, Promise.resolve()];
                case 2: return [2 /*return*/, e.click()];
            }
        });
    }); };
    var focusInput = function () { return __awaiter(void 0, void 0, void 0, function () {
        var elem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isV3) {
                        return [2 /*return*/, select.$('.select-v3__value-container').click()];
                    }
                    if (!(select.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, select.$('.Select-input input').getNative()];
                case 1:
                    elem = _a.sent();
                    Simulate.focus(elem);
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, select.$('.Select-input input').click()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var focusSelect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var elem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isV3) {
                        return [2 /*return*/, select.$('.select-v3__control').click()];
                    }
                    if (!(select.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, select.$('.Select-input').getNative()];
                case 1:
                    elem = _a.sent();
                    Simulate.focus(elem);
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, select.$('.Select-input').click()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var optionAtIndex = function (index) { return selectMenu.$$(isV3 ? '.select-v3__option' : '.Select-option').get(index); };
    var optionWithText = function (text) { return wrapper
        .$$(isV3 ? '.select-v3__option' : '.Select-option')
        .filter(function (elemDriver) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, elemDriver.text()];
            case 1: return [2 /*return*/, (_a.sent()).includes(text)];
        }
    }); }); })
        .get(0); };
    return {
        openSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, focusInput()];
        }); }); },
        openNonSearchSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, focusSelect()];
        }); }); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        option = optionAtIndex(index);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectByText: function (text) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                option = optionWithText(text);
                return [2 /*return*/, mouseDownOnElement(option)];
            });
        }); },
        selectAtIndexNoSearch: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selector = isV3 ? '.select-v3__option' : '.Select-option';
                        return [4 /*yield*/, selectMenu.$$(selector).get(index).click()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        getSelectionTitlesNoSearch: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selector = isV3 ? '.select-v3__option' : '.Select-option';
                        return [4 /*yield*/, focusSelect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, selectMenu.$$(selector).text()];
                }
            });
        }); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = isV3 ? '.select-v3__option' : '.Select-option';
                        return [2 /*return*/, selectMenu.$$(selector)
                                .map(function (e) { return e.text(); })];
                }
            });
        }); },
        selectByOptionClassName: function (cn) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = isV3 ? '.select-v3__option' : '.Select-option';
                        option = selectMenu.$(selector + "." + cn);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectOptionsBySelector: function (sel) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = isV3 ? '.select-v3__option' : '.Select-option';
                        option = selectMenu.$(selector + " " + sel);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        getSelectedValue: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = isV3 ? 'select-v3__single-value' : 'Select-value';
                return [2 /*return*/, select.hasClass(selector) ? select.$("." + selector).text() : ''];
            });
        }); },
        getPlaceholder: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = isV3 ? '.select-v3__placeholder' : '.Select-placeholder';
                return [2 /*return*/, select.$(selector).text()];
            });
        }); },
        enterText: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = isV3 ? '.select-v3__input input' : '.Select-input input';
                        return [2 /*return*/, select.$(selector).enterValue(val)];
                }
            });
        }); },
        isDisabled: function () {
            var disabledSelector = isV3 ? 'select-v3--is-disabled' : 'is-disabled';
            return select.hasClass(disabledSelector);
        },
        isOptionDisabledByIdx: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var className, disabledClassname;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        className = isV3 ? '.select-v3__option' : '.Select-option';
                        disabledClassname = isV3 ? 'select-v3__option--is-disabled' : 'is-disabled';
                        return [2 /*return*/, selectMenu.$$(className).get(idx).hasClass(disabledClassname)];
                }
            });
        }); },
        isSmall: function () { return select.hasClass('small'); },
        noResultsText: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = isV3 ? '.select-v3__menu' : '.Select-noresults';
                return [2 /*return*/, selectMenu.$(selector).text()];
            });
        }); },
        menuFooter: selectMenu.$('.select-menu-footer'),
        base: select
    };
};
//# sourceMappingURL=driver.js.map